<template>

  <div class="footerbox">

    <!-- <p>暖暖星球 www.imlebo.com <a href="https://beian.miit.gov.cn/"> 粤ICP备2020100980号</a>  </p>
                    <p>Copyright© 2017 www.imlebo.com All Rights Reserved &nbsp; &nbsp;广州乐播网络科技有限公司版权所有</p>
                    <p>请所有主播直播时务必遵守国家互联网信息管理办法规定，我们拒绝任何违法直播，一经发现，即刻封号！举报电话：020-85670302</p>
                    <p> <a href="http://jbts.mct.gov.cn/">12318全国文化市场举报网站</a> &nbsp; &nbsp; 
                      <a href="https://www.12377.cn/">中国互联网违法和不良信息举报中心</a> &nbsp; &nbsp;
                      <a href="https://www.12377.cn/node_548446.htm">网络举报APP下载</a> </p> -->
    <!-- <p>暖暖星球 www.imbeiyu.com <a href="https://beian.miit.gov.cn/"> 粤ICP备18108232号-1</a>  </p>
                    <p>Copyright© 2021 www.imbeiyu.com All Rights Reserved &nbsp; &nbsp;广州赛驷网络科技有限公司版权所有</p>
                    <p>请所有主播直播时务必遵守国家互联网信息管理办法规定，我们拒绝任何违法直播，一经发现，即刻封号！举报电话：020-85670302</p>
                    <p> <a href="http://jbts.mct.gov.cn/">12318全国文化市场举报网站</a> &nbsp; &nbsp; 
                      <a href="https://www.12377.cn/">中国互联网违法和不良信息举报中心</a> &nbsp; &nbsp;
                      <a href="https://www.12377.cn/node_548446.htm">网络举报APP下载</a> </p>  -->

    <!-- <p>暖暖星球 www.imbeiyu.com <a href="https://beian.miit.gov.cn/"> 粤ICP备18108232号-1</a> <a href="http://gs.ccm.mct.gov.cn/lic/7f153cb5b8ff462ea6119f88b4d262d5">粤网文[2020]3614-214号</a> </p>
                <p>Copyright© 2017 www.imbeiyu.com All Rights Reserved &nbsp; &nbsp;深圳市辰瑞文化传播有限公司版权所有</p>
                <p>请所有主播直播时务必遵守国家互联网信息管理办法规定，我们拒绝任何违法直播，一经发现，即刻封号！举报电话：020-85670302</p>
                <p> <a href="http://jbts.mct.gov.cn/">12318全国文化市场举报网站</a> &nbsp; &nbsp; <a href="https://www.12377.cn/">中国互联网违法和不良信息举报中心</a> &nbsp; &nbsp; <a href="https://www.12377.cn/node_548446.htm">网络举报APP下载</a> </p>
                <p><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402005710">粤公安备44030402005710号</a> </p> -->

    <!-- <p>暖暖星球 www.xingtutime.com <a href="https://beian.miit.gov.cn/"> 皖ICP备2020018122号</a> <a href="http://qr.ccm.gov.cn/lic/e630b518a1b849c29005159a036744ac">皖网文[2019]2384-106号</a> </p>
                <p>Copyright© 2017 www.xingtutime.com All Rights Reserved &nbsp; &nbsp;合肥星途时代网络科技有限公司版权所有</p>
                <p>请所有主播直播时务必遵守国家互联网信息管理办法规定，我们拒绝任何违法直播，一经发现，即刻封号！举报电话：020-85670302</p>
                <p> <a href="http://jbts.mct.gov.cn/">12318全国文化市场举报网站</a> &nbsp; &nbsp; 
                <a href="https://www.12377.cn/">中国互联网违法和不良信息举报中心</a> &nbsp; &nbsp; <a href="https://www.12377.cn/node_548446.htm">网络举报APP下载</a> </p>
                <p><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010302001960">皖公网安备34010302001960号</a> </p> -->


    <p>暖暖星球 <a href="https://beian.miit.gov.cn/"> {{ ipc }}</a> </p>
    <!-- <p> 增值电信业务经营许可证B2-20173141</p> -->
    <!-- <p><a href="http://gs.ccm.mct.gov.cn/lic/7f153cb5b8ff462ea6119f88b4d262d5">粤网文[2020]3614-214号</a> </p> -->
    <p>Copyright© 2017 nnxq All Rights Reserved &nbsp;暖暖星球版权所有</p>
    <p>请所有主播直播时务必遵守国家互联网信息管理办法规定，我们拒绝任何违法直播，一经发现，即刻封号！举报电话：020-89810547</p>
    <p> <a href="http://jbts.mct.gov.cn/">12318全国文化市场举报网站</a> &nbsp; &nbsp; <a
        href="https://www.12377.cn/">中国互联网违法和不良信息举报中心</a> &nbsp; &nbsp; <a
        href="https://www.12377.cn/node_548446.htm">网络举报APP下载</a> </p>
    <div>
      <img src="../assets/PC/gongan.png">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602010619">粤公网安备44010602010619号</a>
    </div>

  </div>


</template>
<script>
export default {
  name: 'Footer',
  props: {
    type: String,
    tabindex: "",
    require: true
  },
  data() {
    return {
      ipc: '',
      isGa: false,
    }
  },
  created() {
    // this.play();
    console.log(window.screen.width)
    let url = window.location.href
    this.ipc = '粤ICP备18108232号'
    this.isGa = true;


  },
  methods: {

  },
}
</script>
<style lang="less" scoped>
.footerbox {
  width: 100%;
  height: 2rem;
  background: #Fff;
  // margin-top: .6rem;
  // padding-top: .25rem;
  box-sizing: border-box;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: .3rem;
  }

  p,
  div {
    text-align: center;
    width: 100%;
    font-size: .075rem;
    color: rgba(102, 102, 102, 1);
    line-height: .17rem;

    a {
      color: rgba(102, 102, 102, 1);
    }

    img {
      width: .1rem;
    }

    a:hover {
      color: #40a9ff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue